/** Shared dropdown/menu paper surface. */
import { IPD_COLORS } from "./ipdColors";
import { getIpdSelectMenuProps } from "./ipdFieldStyles";

const menuPaperFromIpd = getIpdSelectMenuProps().PaperProps?.sx || {};

export const menuPaperSx = {
  ...menuPaperFromIpd,
  backgroundColor: IPD_COLORS.cardBg,
  border: `1px solid ${IPD_COLORS.border}`,
  color: IPD_COLORS.textPrimary,
  '& .MuiMenuItem-root:hover': { backgroundColor: 'rgba(26, 43, 75, 0.05)' },
  '& .MuiMenuItem-root.Mui-selected': { backgroundColor: IPD_COLORS.selectedBg },
};
